// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Error as StaticError } from 'gandi.react-static-pages';

import styles from './Error.scss';

export type Props = {
  className?: string,
  ...
};

export function Error({ className, ...extraProps }: Props): React.Node {
  return (
    // $FlowFixMe[cannot-spread-inexact]
    <StaticError className={clsx(styles.root, className)} {...extraProps} />
  );
}
